import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-loader" }
const _hoisted_2 = { class: "b-loader__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "m-loader" }, null, -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$msg('customer.brief.loader.label')), 1)
  ]))
}